import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { getGameLink } from "../redux/slices/games/getGameListSlice";
import Footer from "./layout/footer";
import Navbar from "./layout/navbar";
import Loader from "../components/common/loader";

const GameSection = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [game, setGame] = useState(null);
  const { loading, error, data } = useSelector((state) => state.getGameLink);

  const { error: profileError, data: profileData } = useSelector(
    (state) => state.getProfile
  );

  useEffect(() => {
   
    if (location.state.game_id) {
      handleGameLaunch();
    }
  }, [location]);

  const handleGameLaunch = () => {
    dispatch(
      getGameLink({
        gameId: location.state.game_id, // "151053", 150001
      })
    )
      .unwrap()
      .then((res) => {
        if (res.status == 200) {
          setGame(res);
        } else if (res.status == 400) {
          // toast.error(res.message);
          setGame(res);
        }

       
      })
      .catch((error) => {
        toast.error(error.message);
        console.error("Failed :", error);
      });
  };
  

  return (
    <>
      
      <Navbar />

      <div className="my-2 mx-1">
       
       {data?.willUseBonus && <span className="text-white">Your Bonus can be used If you have.</span>}
        {loading && <Loader />}
        {game?.status === 200 && game?.data && (
          // eslint-disable-next-line jsx-a11y/iframe-has-title
          <iframe
            width={"100%"}
            height={800}
            // src={"https://stage-color.mac88.com?token=71be88c9-7046-459d-b8ae-c5b0423a41f9&operatorId=gapmac88&userName=medisa&partnerId=GAPINR&providerId=MAC88&lobby=false&gameId=VGPOK101&opentable=VTGPOK101&theme=DARK&view=CLASSIC&lobbyType=LIVE:VIRTUAL"

            src={game?.data}
            // src="https://aviatorx-preprod.mac88.com/aviatorx/index.html?token=694d945d-e692-4219-8b0a-398e5f5d2946&operatorId=gapmac88&userName=sid&partnerId=GAPINR&providerId=MAC88&lobby=false&gameId=VGCAV101&opentable=VTGCAV101&theme=DARK&view=CLASSIC&lobbyType=LIVE:VIRTUAL%22"
          />
        )}
        {game?.status == 400 && (
          <div>
            <h2 className="fw-bold hero-heading text-danger">
              {typeof game.message === "string"
                ? game.message
                : JSON.stringify(game.message)}
            </h2>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default GameSection;
